import React from 'react';

const MissionSection = () => {
  return (
    <section style={{ background: '#050A12', padding: '120px 0', position: 'relative', overflow: 'hidden' }}>
      {/* Background texture */}
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(59,111,212,0.06) 0%, transparent 60%), radial-gradient(circle at 80% 20%, rgba(59,111,212,0.04) 0%, transparent 50%)'
      }} />
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%', position: 'relative', zIndex: 1 }}>
        {/* Section label */}
        <div style={{
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: '0.6875rem',
          color: '#3B6FD4',
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          marginBottom: '60px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
          VÅR MISJON
        </div>

        {/* Asymmetric grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '3fr 2fr', gap: '0', position: 'relative' }}>
          {/* Mission block */}
          <div style={{
            background: 'rgba(59,111,212,0.08)',
            border: '1px solid rgba(59,111,212,0.2)',
            padding: '60px',
            clipPath: 'polygon(0 0, 100% 0, calc(100% - 40px) 100%, 0 100%)'
          }}>
            <div style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#3B6FD4',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '20px'
            }}>MISJON</div>
            <h2 style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              letterSpacing: '-0.03em',
              lineHeight: 1.1,
              marginBottom: '24px'
            }}>
              Gjøre norske veier
              <br /><span style={{ color: '#3B6FD4' }}>tilgjengelige</span> for alle
            </h2>
            <p style={{
              fontFamily: 'Lora, serif',
              fontSize: '1.0625rem',
              color: 'rgba(238,240,242,0.7)',
              lineHeight: 1.8
            }}>
              Vi tror at alle norske sjåfører fortjener enkel tilgang til presis veginformasjon, rettferdige bompriser og pålitelig navigasjon — uansett om du kjører en elbil i Oslo eller en lastebil over Dovrefjell.
            </p>
          </div>

          {/* Vision block */}
          <div style={{
            background: 'rgba(255,255,255,0.02)',
            border: '1px solid rgba(255,255,255,0.06)',
            padding: '60px 60px 60px 80px',
            marginLeft: '-40px'
          }}>
            <div style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: 'rgba(138,149,163,0.6)',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '20px'
            }}>VISJON</div>
            <h2 style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              letterSpacing: '-0.03em',
              lineHeight: 1.1,
              marginBottom: '24px'
            }}>
              Norges smarteste
              <br />veiplattform
            </h2>
            <p style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.9375rem',
              color: 'rgba(138,149,163,0.8)',
              lineHeight: 1.8
            }}>
              Innen 2030 vil NordPass være den foretrukne plattformen for alle som ferdes på norske veier — fra daglige pendlere til langtransportsjåfører og turister.
            </p>

            {/* Values list */}
            <div style={{ marginTop: '32px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {['Norsk kvalitet', 'Åpenhet', 'Bærekraft', 'Innovasjon']?.map((val, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ width: '6px', height: '6px', background: '#3B6FD4', transform: 'rotate(45deg)', flexShrink: 0 }} />
                  <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', color: 'rgba(238,240,242,0.6)' }}>{val}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Large quote */}
        <div style={{
          marginTop: '80px',
          padding: '60px',
          background: 'rgba(255,255,255,0.02)',
          borderLeft: '4px solid #3B6FD4',
          position: 'relative'
        }}>
          <div style={{
            position: 'absolute',
            top: '-20px',
            left: '40px',
            fontFamily: 'Syne, sans-serif',
            fontSize: '6rem',
            fontWeight: 800,
            color: 'rgba(59,111,212,0.15)',
            lineHeight: 1
          }}>"</div>
          <blockquote style={{
            fontFamily: 'Lora, serif',
            fontStyle: 'italic',
            fontSize: 'clamp(1.25rem, 2vw, 1.75rem)',
            color: 'rgba(238,240,242,0.85)',
            lineHeight: 1.6,
            margin: 0
          }}>
            Vi bygget NordPass fordi vi selv var frustrerte over mangelen på gode verktøy for norske sjåfører. Det er ikke bare et produkt — det er en kjærlighet til dette landet og dets veier.
          </blockquote>
          <div style={{ marginTop: '24px', fontFamily: 'Syne, sans-serif', fontSize: '0.875rem', fontWeight: 700, color: '#3B6FD4', letterSpacing: '0.08em' }}>
            — ERIK NORDMANN, GRUNNLEGGER & CEO
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
